export const contact = {
    topic_sv: "Kontakta oss",
    text1_sv: "Vill ni veta mer om oss? Kontakta oss gärna!",
    email_text_sv: "E-post",
    phone_text_sv: "Telefon",
    email_address_sv: "info@firebric.se",
    phone_number_sv: "070-350 14 02"
}
